/*
 * File: Loader.tsx
 * Project: rosita
 * -----
 * Last Modified: 18 Feb 2022 4:40:21 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Col, Layout, Row } from 'antd';
import { BlockLoader } from 'components/atoms/BlockLoader';
import React from 'react';
import { InlineStylesModel } from '../../models/InlineStylesModel';

const { Content } = Layout;

const styles: InlineStylesModel = {
  content: {
    textAlign: 'center'
  },
  layout: {
    width: '100vw',
    height: '100vh'
  },
  mainRow: {
    height: '100vh'
  }
};

export const Loader = (): JSX.Element => {
  return (
    <Layout style={styles.layout}>
      <Content style={styles.content}>
        <Row justify="center" align="middle" style={styles.mainRow}>
          <Col span={24}>
            <BlockLoader direction="loader loader--slideUp" />
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};
